import React from "react";

const BASE = import.meta.env.BASE_URL;

function Side({ name, card, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/winner.png`} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>{" "}
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/cards/${card}.png`} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 1 CARD 20-20 (teen120):
 * Player = card[0], Dealer = card[1]; trophy before the winner's card (win 1 / 2);
 * rdesc "winner#pair" → Winner / Pair.
 */
export default function Teen120ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <Side name="Player" card={cards[0]} isWinner={win === "1"} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <Side name="Dealer" card={cards[1]} isWinner={win === "2"} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Pair</div> <div>{desc[1]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
